import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueKonva from 'vue-konva'
import '@/assets/css/basic.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import _ from 'lodash'
import store from '@/store'
import '@/utils/base'
import tab from '@/components/tab.vue'
import account from '@/components/account.vue'
import pageTitle from '@/components/pageTitle.vue'
import ruleView from '@/components/ruleView.vue'
import confirm from '@/components/confirm.vue'
import agreement from '@/components/agreement.vue'
import guide from '@/components/guide.vue'
import share from '@/components/share.vue'
import setConfirm from '@/components/setConfirm.vue'
import empower from '@/components/empower.vue'
Vue.component('empower', empower)
Vue.component('setConfirm', setConfirm)
Vue.component('share', share)
Vue.component('guide', guide)
Vue.component('agreement', agreement)
Vue.component('confirm', confirm)
Vue.component('ruleView', ruleView)
Vue.component('pageTitle', pageTitle)
Vue.component('tab', tab)
Vue.component('account', account)
Vue.use(ElementUI)

Vue.use(VueKonva)
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
